export default "__VITE_ASSET__a474f9ba__"